// extracted by mini-css-extract-plugin
export default {"head":"style_head__ZjkhN","head1":"style_head1__iUs6U","para":"style_para__7q3D+","para1":"style_para1__yVUns","linkhead":"style_linkhead__f8a-h","noprint":"style_noprint__gd3pC"};